import PropTypes from 'prop-types';
import Modal from '../../shared/modal';
import Button from '../../shared/buttons/button';

function ResetModalStepSuccess(props) {
  return (
    <Modal
      showModal
      onClose={props.onClose}
      header={<span className='text-red-400'>بازنشانی فلش کارت‌ها</span>}
      body={
        <div className='text-base'>
          <p>
            <span>بازنشانی فلش کارت های </span>
            <span className='font-semibold'>{props.itemLabel}</span>
            <span> با </span>
            <span className='font-medium text-green-500'>موفقیت</span>
            <span> انجام شد.</span>
          </p>
        </div>
      }
      footer={
        <div className='flex justify-end'>
          <Button color='red' content='بازگشت' onClick={props.onClose} />
        </div>
      }
    />
  );
}

ResetModalStepSuccess.propTypes = {
  itemLabel: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ResetModalStepSuccess;
